import { ClientDetails } from '@models/client'

export const hasActiveSubscriptionContract = (client: ClientDetails | null): boolean =>
  client
    ? client.subscription_contracts.some(subscriptionContract => subscriptionContract.status === 'confirmed')
    : false
